<ng-content select="accredible-tile-header" />

<ng-content select="accredible-tile-content" />

<ng-content />
